export default {
  'en-US': {
    cookieConsent: {
      p: 'This website uses cookies to improve your experience. By continuing to browse the site, you are agreeing to our use of cookies. Review our {link} for more details.',
      link: 'Privacy Policy',
    },
    cta: {
      continue: 'Continue',
      close: 'Close',
      login: 'Log In',
      processing: 'Processing',
      signIn: 'Sign In',
      subscribe: 'Subscribe',
      noCcTrial: 'START NO-CC TRIAL',
      tooManyAttempts: 'Return Home',
    },
    footer: {
      appStore: {
        alt: 'Download on the App Store',
        title: 'Apple App store - link to Neat app',
      },
      playStore: {
        alt: 'Get it on Google Play',
        title: 'Google Play store - link to Neat app',
      },
      bbbAlt: 'BBB Accredited Business',
      recaptchaTerms: 'This site is protected by reCAPTCHA and the Google {privacyLink} and {termsLink} apply.',
    },
    label: {
      email: 'Email',
      firstName: 'First Name',
      lastName: 'Last Name',
      password: 'Password',
      plan: 'Plan',
      phone: 'Mobile Number',
    },
    pages: {
      emailPreferences: {
        subscribe: {
          success: 'You have successfully subscribed to receive emails from Neat!',
        },
      },
      signUp: {
        form: {
          selectPlan: {
            nextButton: 'Continue',
            baseTooltip: 'Neat base subscription is required to continue.',
            side: {
              features: {
                files: 'Unlimited file storage',
                'data-capture': 'Data capture with human verification',
                'unlimited-support': 'Unlimited email & chat support',
                expenses: 'Track your expenses',
                filter: ' Easily filter and search for documents',
                'file-sharing': 'File sharing and collaboration',
                encryption: 'Bank-level security encryption',
                accessible: 'Accessible from anywhere',
                'help-center': 'Access to our Help Center Knowledge Base',
              },
            },
          },
          authenticate: {
            accountHeading: 'Create your Neat account',
            heading: {
              buyNeat: 'Buy a plan today.<br></br><em>30-day money back</em><br></br>guarantee!',
              buyNeatHome: 'Buy NeatHome today.<br></br><em>30-day money back</em><br></br>guarantee!',
              trialNeat: 'Start your <em>FREE</em> 14-day,<br></br>risk-free trial',
              trialNeatHome: 'Start your <em>FREE</em> 14-day,<br></br>risk-free trial & access<br></br>NeatHome today!',
              trialNeatSubhead: "Access Neat's Base plan today.",
            },
            nextButton: 'Continue with Email',
            separator: 'or continue with email',
          },
          newUser: {
            heading: 'Create your account',
            subheading: "Let's set up your account details.",
            nextButton: 'Next Step: Payment Details',
          },
          billing: {
            submit: 'Finalize Purchase',
            addCoupon: 'Apply',
            removeCoupon: 'Remove',
            submitTrial: 'Start My FREE 14-Day Trial',
            paypal: 'Continue to PayPal',
          },
          existingUser: {
            welcomeBack: 'Welcome back!',
            resetPassword: 'Reset my password',
            greeting: 'Hi <strong>{firstName} {lastName}</strong>',
            redirectToNeat: 'Click here to redirect',
            existingUserRedirect: 'You can view and manage your subscription from the My Subscription setting within the app. You will be redirected in 10 seconds. If you are not redirected please click the link below.',
          },
          upsell: {
            getVip: 'Yes, give me VIP Service',
          },
        },
        unexpectedError: 'Oops! We encountered an unexpected error and our engineers have been alerted. If the problem persists, please contact Neat customer support.',
        requestValidationError: 'Oops! We encountered an unexpected error and our engineers have been alerted. If the problem persists, please contact Neat customer support for assistance placing your order.',
      },
    },
  },
}
